import {
  createContext,
  useContext,
  type Dispatch,
  type SetStateAction,
} from "react";
import { type RouteParams } from "shared/api/types/society/[societyId]/app-route-config";
import { type SocietyAuthBodyInput } from "shared/api/types/society/[societyId]/auth";
import { type SessionView } from "shared/mappers/database/session/session";
import type { AsyncFunction } from "shared/types/AsyncFunction";

export interface CustomSessionType extends SessionView {
  //both
  setSession: Dispatch<SetStateAction<SessionView | null>>;
  //hub
  logout: () => Promise<void>;
  login: (loginDetails: Required<SocietyAuthBodyInput>) => Promise<void>;
  token: (token: string) => Promise<void>;
  refreshSession: (
    redirectUrlAfterLogin?: string,
    routeParams?: RouteParams,
  ) => Promise<void>;
  routeSocietyId?: number | null;
  withAuthentification: <Callback extends AsyncFunction>(
    callback: Callback,
  ) => (...args: Parameters<Callback>) => ReturnType<Callback> | Promise<void>;
  isPhoneMedia: boolean;
}

const CustomSessionContext = createContext<CustomSessionType | null>(null);

const useCustomSession = (): CustomSessionType => {
  const session = useContext(CustomSessionContext);
  if (session === undefined) {
    throw new Error(
      "useCustomSession must be used within a CustomSessionContext",
    );
  }
  if (session === null) {
    throw new Error("CustomSessionContext is null");
  }
  return session;
};

export { CustomSessionContext, useCustomSession };
